export default {"src":"/_next/static/media/premium-landing-purple.1f363027.svg","height":277,"width":387,"blurWidth":0,"blurHeight":0};